export default {
  notSubmitted: 1,
  submitted: 2,
  approved: 3,
  denied: 4,
};
